// import { post } from './http';

// let abortController;

// export const getProductList = async (q) => {
//   // abort any existing, pending request.
//   // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
//   abortController && abortController.abort();
//   abortController = new AbortController();
//   if (!q) {
//     return;
//   }
//   return await post('/api/quickSearch', q, abortController).then((response) =>
//     response.json()
//   );
// };

// export const getProductsByQuery = async (q) => {
//   // abort any existing, pending request.
//   // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
//   abortController && abortController.abort();
//   abortController = new AbortController();
//   return await post('/api/checkout/getProductsByQuery', q, abortController).then(
//     (response) => response.json()
//   );
// };

import { post } from './http';

let abortController;

/**
 * Makes an API request with abort controller functionality
 * @param {string} endpoint - The API endpoint to call
 * @param {Object} query - The query parameters
 * @returns {Promise<Object>} The parsed JSON response
 */
const makeRequest = async (endpoint, query) => {
  if (!query) {
    return Promise.resolve(null);
  }

  // Abort any existing pending request
  if (abortController) {
    abortController.abort();
  }
  
  abortController = new AbortController();
  
  try {
    const response = await post(endpoint, query, abortController);
    return await response.json();
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.error('API request failed:', error);
      throw error;
    }
    return null;
  }
};

export const getProductList = (query) => 
  makeRequest('/api/quickSearch', query);

export const getProductsByQuery = (query) => 
  makeRequest('/api/checkout/getProductsByQuery', query);
